import { Outlet } from "react-router-dom";
const Setting = () => {
  return <div>Setting <Outlet /></div>;
};

export default Setting;
